
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Do, Dont, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  A content item is mostly used to provide a quick overview of an element in a
  text-heavy listing pages, like news or events, supporting users
  decision-making.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/ContentItem/Anatomy_img_desktop.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/ContentItem/Anatomy_img_mobile.jpg 892w, https://inno-ecl.s3.amazonaws.com/media/images/EC/ContentItem/Anatomy_img_desktop.jpg 1468w" alt="Anatomy of content item" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary Meta`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary Meta it describes the item content type and it’s written in sentence case but styled to feature in uppercase`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A separator is required between meta and date`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The item title can be linked or not`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Summary`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provide users only the essential information needed to decide which item access the details`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Secondary Meta`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Secondary metadata is composed of an icon and a label. It can be added to provide additional information about a specific item's content such as the location or the availability of live streaming of an event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The image requires a 3:2 ratio and can be left or right aligned`}</td>
        </tr>
      </tbody>
    </table>
    <h4>{`Guidance`}</h4>
    <ul>
      <li parentName="ul">{`content items should be easy to scan, avoid large titles and large paragraphs`}</li>
      <li parentName="ul">{`display images on the right only to enrich the displayed content not being main information for the user, otherwise use images on the left`}</li>
    </ul>
    <h2>{`Do's and don'ts`}</h2>
    <Do title="Do" image="https://inno-ecl.s3.amazonaws.com/media/images/EC/ContentItem/content-item-do-desktop.jpg" alt="" description="Use content items consistently through the list." mdxType="Do" />
    <Dont title="Don't" image="https://inno-ecl.s3.amazonaws.com/media/images/EC/ContentItem/content-item-dont-desktop.jpg" alt="" description="Do not mix different content items on the same list as it will affect scannability." mdxType="Dont" />
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`use content items when you want to display a list of events, news, agenda or other similar types of data`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not use for navigation purpose; use `}<Link to="/eu/templates/compositions/navigation-lists/usage/" mdxType="Link">{`navigation lists`}</Link>{` instead`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;